import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faCogs } from "@fortawesome/free-solid-svg-icons";
import { useDevice } from "../layout/DeviceContext";

export default function DashboardHome() {
    const navigate = useNavigate();

    const {
        device,
        uplinks = [],
        ponPorts = [],
        onuStats = { total: 0, online: 0, offline: 0 },
        selectedPon,
        setSelectedPon,
        refresh
    } = useDevice();

    // ponPorts undefined বা null হওয়া থেকে সুরক্ষার জন্য safe check
    const safePonPorts = Array.isArray(ponPorts) ? ponPorts : [];
    const safeUplinks = Array.isArray(uplinks) ? uplinks : [];

    // Safe find check (যাতে undefined থাকলে ক্র্যাশ না করে)
    const activePon = safePonPorts.find(
        p => p?.port_name === selectedPon
    );

    return (
        <>
            <div className="main-action-bar">
                <button
                    className="btn refresh"
                    onClick={refresh}
                >
                    <FontAwesomeIcon icon={faSyncAlt} />
                    Refresh
                </button>

                <button
                    className="btn advanced"
                    onClick={() =>
                        navigate(
                            `/olt-manage/dashboard/${device?.device_id || device?.id}/advanced`
                        )
                    }
                    disabled={!device}
                >
                    <FontAwesomeIcon icon={faCogs} />
                    Advanced
                </button>
            </div>

            {/* ============================ */}
            {/* UPLINK STATUS                */}
            {/* ============================ */}
            <section className="table-container">
                <div className="table-title">
                    Uplink Status
                </div>
                <table className="olt-styled-table">
                    <thead>
                        <tr>
                            <th>Interface</th>
                            <th>Speed</th>
                            <th>Status</th>
                            <th>RX/TX</th>
                        </tr>
                    </thead>
                    <tbody>
                        {safeUplinks.length > 0 ? (
                            safeUplinks.map((up, index) => (
                                <tr key={up?.port_name || index}>
                                    <td>{up?.port_name || "N/A"}</td>
                                    <td>{up?.speed || "N/A"}</td>
                                    <td>{up?.status || "N/A"}</td>
                                    <td>
                                        RX {up?.rx_power || "N/A"}
                                        &nbsp;&nbsp;
                                        TX {up?.tx_power || "N/A"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center" }}>No Uplink Data Available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </section>

            {/* ============================ */}
            {/* SELECTED PON                 */}
            {/* ============================ */}
            <section
                className="table-container"
                style={{ marginTop: 20 }}
            >
                <div className="table-title">
                    Selected PON
                </div>

                <div style={{ marginBottom: 15 }}>
                    <select
                        className="styled-select dark"
                        value={selectedPon || ""}
                        onChange={(e) => setSelectedPon && setSelectedPon(e.target.value)}
                    >
                        {safePonPorts.map((p) => (
                            <option
                                key={p?.port_name}
                                value={p?.port_name}
                            >
                                {p?.port_name}
                            </option>
                        ))}
                    </select>
                </div>

                <table className="olt-styled-table">
                    <thead>
                        <tr>
                            <th>PON</th>
                            <th>Registered</th>
                            <th>Online</th>
                            <th>Offline</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activePon ? (
                            <tr>
                                <td>{activePon.port_name}</td>
                                <td>{activePon.registered ?? 0}</td>
                                <td>{activePon.online ?? 0}</td>
                                <td>{activePon.offline ?? 0}</td>
                                <td>{activePon.status || "Unknown"}</td>
                            </tr>
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>No PON Port Selected</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </section>

            {/* ============================ */}
            {/* ONU STATS PILLS              */}
            {/* ============================ */}
            <div className="bottom-stats-row">
                <div className="stat-pill blue">
                    REG ONU
                    <span>
                        {onuStats?.total ?? 0}
                    </span>
                </div>

                <div className="stat-pill green">
                    ONLINE
                    <span>
                        {onuStats?.online ?? 0}
                    </span>
                </div>

                <div className="stat-pill red">
                    OFFLINE
                    <span>
                        {onuStats?.offline ?? 0}
                    </span>
                </div>
            </div>
        </>
    );
}